import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'
import user from './user';
import token from './token';
import dailyVideo from './dailyVideo';
import ad from './ad';
import magazine from './magazine';

// root reducer
export default combineReducers({
  user,
  token,
  dailyVideo,
  ad,
  magazine,
  form: formReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js